export default __webpack_public_path__ + "static/media/mcc-logo.edef8492.png";